import { render, staticRenderFns } from "./FitoFertilityProductSelectorMobile.vue?vue&type=template&id=3056b508&scoped=true"
import script from "./FitoFertilityProductSelectorMobile.vue?vue&type=script&lang=js"
export * from "./FitoFertilityProductSelectorMobile.vue?vue&type=script&lang=js"
import style0 from "./FitoFertilityProductSelectorMobile.vue?vue&type=style&index=0&id=3056b508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056b508",
  null
  
)

export default component.exports